import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Container, Divider, Grid, Paper, TextField, Theme, Typography, createStyles, makeStyles, colors, Table, TableBody, TableCell, TableHead, TableRow, TableContainer, Select, MenuItem, FormHelperText, FormControl, InputLabel } from '@material-ui/core';
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { FanData } from '../app/utils/models';
import { createNewModel, updateModel, newProjectResponse } from "../app/reducer/fanUpload.reducer";
import { useAppSelector } from "../app/hooks";
import AlertComponent from "../components/general/Alert";
import { FanUploadProps } from './Fans'
import Chart from "react-google-charts";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    radioGroup: {
      display: 'flex',
      flexDirection: 'row'
    },
    formControl: {
      width: '100%',
    },
    radioWrapped: {
      marginLeft: theme.spacing(2),
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    redOutline: {
      borderColor: "red !important"
    },
    uppercaseText: {
      textTransform: 'uppercase'
    },
    cellBox: {
      width: '100px',
      margin: '0 20px'
    },
    textField: {
      width: '100px'
    }
  }),
);

interface LocationState {
  selectedValue?: string;
  fanAction?: string
}

const FanDetails: React.FC<FanUploadProps> = ({ setIndex, modelId, selectedFan, setVisibleModule, userUpdatedData }: FanUploadProps) => {

  // const r1 = selectedFan.rpm ? parseInt(selectedFan.rpm) : 1;
  // const r2 = selectedFan.rpm2 ? parseInt(selectedFan.rpm2) : r1;
  // const a1 = selectedFan.airDensity ? selectedFan.airDensity : 1.2;
  // const a2 = selectedFan.airDensity2 ? selectedFan.airDensity2 : a1;

  const { register, handleSubmit, setValue, getValues, control, formState: { errors }, setError, reset } = useForm<FanData>();
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation<LocationState>();
  const locationState = location.state || {};
  const [inputValue, setInputValue] = useState('');
  // const [scalingFactor,setScalingFactor] = useState<number>((r2/r1)*(a2/a1));
  const [modelExistError, setErrorResponse] = useState<any | undefined>('');


  const [fieldDisabled, setFieldDisabled] = useState({
    fanModelID: false,
    fanDiameter: false,
    airDensity: false,
    numofBlades: false,  // made the number of blade field editable.
    rpm: false,
    curveType: false,
    netFreeArea: true,
    fanCasingDiameter: true,
    bladeModel: true,
    hub: true,
    octaveBand: true,
    gaDrawing: true,
    clientName: false,
    projectName: false,
    location: false,
    airDensity2: false,
    rpm2: false,
    hubDiameter: true, // Added for hubDiameter
  });
  const [buttonAction, setButtonAction] = useState<string>('Edit');
  const [openAlert, setOpenAlert] = React.useState<boolean>(false);
  const [openAlertMesage, setOpenAlertMessage] = React.useState<string>("");
  const [angles, setAngles] = React.useState<string[]>([]);
  const [rpmDefault, setRpmDefault] = React.useState<any>();
  const [airDensityDefault, setAirDensityDefault] = React.useState<any>();
  const [rpm2, setRpm2] = React.useState<any>();
  const [airDensity2, setAirDensity2] = React.useState<any>();
  const [totalPressureData, setTotalPressureData] = React.useState<any[]>([]);
  const [totalPressureGraphData, setTotalPressureGraphData] = React.useState<any[]>([]);
  const [staticPressureGraphData, setStaticPressureGraphData] = React.useState<any[]>([]);
  const [FanShaftGraphData, setFanShaftGraphData] = React.useState<any[]>([]);
  const [hederRow, setHederRow] = React.useState<any[]>([]);
  const [performanceCurvesData, setPerformanceCurves] = React.useState<any[]>([]);

  var options = {
    curveType: 'function',
    legend: { position: 'right' },
    crosshair: { trigger: 'selection' },
    hAxis: {
      format: "0"
    },
    vAxis: {
      format: "0"
    },

  };

  const onBack = () => {
    if (setIndex) {
      setIndex(4);
    }
  }

  useEffect(() => {
    (async () => {
      if (setIndex) {
        setIndex(5);
      }
      debugger;
      if (selectedFan) {
        console.log("selectedFan", selectedFan);
        const { newValues } = await updateNewValues(selectedFan) as Record<string, any>;
        Object.keys(newValues).forEach((fieldName: any) => {
          if (fieldName === "bladeModel")
            setValue(fieldName, userUpdatedData.modelId ? userUpdatedData.modelId : selectedFan[fieldName].bladeModelID);
          else if (fieldName === "hub")
            setValue(fieldName, userUpdatedData.hubID ? userUpdatedData.hubID : selectedFan[fieldName].hubID);
          else if (fieldName === "octaveBand")
            setValue(fieldName, userUpdatedData.octaveBandID ? userUpdatedData.octaveBandID : selectedFan[fieldName].octaveBandID);
          else if (fieldName === "gaDrawing")
            setValue(fieldName, userUpdatedData.gaDrawingID ? userUpdatedData.gaDrawingID : selectedFan[fieldName].gaDrawingID);
          else if (fieldName === "airDensity")
            setValue(fieldName, selectedFan['airDensity'] ? selectedFan['airDensity'] : 1.2);
          else {
            setValue(fieldName, newValues[fieldName]);
            console.log("I ran", fieldName, newValues[fieldName])
          }
        });
      }

      // setScalingFactor((r2/r1)*(a2/a1));
      performanceCurves();
    })();
  }, []);

  // Register form fields
  useEffect(() => {
    register('performance_curves');
    register('hubDiameter'); // Added to register hubDiameter
  }, [register]);

  // Sync performance_curves with form state
  useEffect(() => {
    setValue('performance_curves', performanceCurvesData);
  }, [performanceCurvesData, setValue]);

  // Sync hubDiameter, netFreeArea, and fanCasingDiameter when userUpdatedData.hubDiameter changes
  useEffect(() => {
    if (userUpdatedData.hubDiameter) {
      const hubDiameter = userUpdatedData.hubDiameter;
      setValue('hubDiameter', hubDiameter);

      // Recalculate fanCasingDiameter and netFreeArea
      const fanDiameter = getValues('fanDiameter') || selectedFan.fanDiameter || 1;
      const tipClarence = 0.0045 * fanDiameter;
      const casingDiameter = fanDiameter + (2 * tipClarence);
      const netFreeArea = 0.785 * ((casingDiameter * casingDiameter) - (hubDiameter * hubDiameter));

      setValue('fanCasingDiameter', isFinite(casingDiameter) ? Number(casingDiameter.toFixed(3)) : casingDiameter);
      setValue('netFreeArea', netFreeArea ? Number(netFreeArea.toFixed(2)) : netFreeArea);
    }
  }, [userUpdatedData.hubDiameter, setValue, getValues, selectedFan?.fanDiameter]);

  const performanceCurves = async () => {
    const data = selectedFan?.performance_curves;
    console.log(selectedFan);
    console.log("performance curves", data);
    setPerformanceCurves(data);
    let angles: string[] = [];
    let graphHeaderData = ['Airflow'];

    for (let i = 0; i < data?.length; i++) {
      for (let j = 0; j < data[i].plotPoints.length; j++) {
        for (let k = 0; k <= angles.length; k++) {
          if (angles.length === 0) {
            angles.push(data[i].plotPoints[j].graphAngle);
            graphHeaderData.push(data[i].plotPoints[j].graphAngle);
          }
          if (data[i].plotPoints[j].graphAngle === angles[k]) {
            break;
          } else if (k === angles.length - 1) {
            angles.push(data[i].plotPoints[j].graphAngle);
            graphHeaderData.push(data[i].plotPoints[j].graphAngle);
          }
        }
      }
    }
    setAngles(angles);
    console.log(angles, graphHeaderData);
    let tmpTotalPressureData = [];
    let tmpStaticPressureData = [];
    let tmpFanShaftData = [];
    let tmpStaticAndTotalPressureData = [];

    console.log("###graphHeaderData", graphHeaderData);
    tmpTotalPressureData.push([...graphHeaderData,'PV']);
    tmpStaticPressureData.push(graphHeaderData);
    tmpFanShaftData.push(graphHeaderData);

    for (let i = 0; i < data?.length; i++) {
      let totalPressureDataRow = [];
      let staticPressureDataRow = [];
      let fanShaftDataRow = [];
      let staticAndTotalPressureDataRow = [];

      const rpm1 = selectedFan.rpm ? parseInt(selectedFan.rpm) : 1;
      const rpm2 = selectedFan.rpm2 ? parseInt(selectedFan.rpm2) : rpm1;
      console.log("RPM2", rpm2)
      const air_density1 = selectedFan.airDensity ? selectedFan.airDensity : 1.2;
      const air_density2 = selectedFan.airDensity2 ? selectedFan.airDensity2 : air_density1;
      console.log((rpm2 / rpm1), (air_density2 / air_density1), (rpm2 / rpm1) * (air_density2 / air_density1))
      const airFlow = data[i].flow * (rpm2 / rpm1); // air flow check // remove (air_density2 / air_density1)  
      console.log(selectedFan)
      setRpmDefault(rpm1);
      setAirDensityDefault(air_density1);
      setRpm2(rpm2);
      setAirDensity2(air_density2);
      // console.log(scalingFactor)
      totalPressureDataRow.push(airFlow ? parseInt(airFlow.toString()) : airFlow);
      staticPressureDataRow.push(airFlow ? parseInt(airFlow.toString()) : airFlow);
      // console.log("airflow",airFlow,airFlow/scalingFactor);
      staticAndTotalPressureDataRow.push(airFlow ? parseInt((airFlow / (rpm2 / rpm1)).toString()) : airFlow);
      fanShaftDataRow.push(airFlow ? parseInt(airFlow.toString()) : airFlow);
      console.log(airFlow, rpm1, rpm2, airDensity2, air_density1)
      for (let j = 0; j < angles.length; j++) {
        const xx = data[i].plotPoints.find((item: any) => item.graphAngle == angles[j]);
        let tp1 = parseFloat(xx ? (xx.total_pressure ? xx.total_pressure.toFixed(2) : xx.total_pressur) : null);
        let eff = parseFloat(xx ? (xx.efficiency ? xx.efficiency.toFixed(2) : xx.efficiency) : null);
        const tp_scaled = xx ? tp1 * (rpm2 / rpm1) * (air_density2 / air_density1) : null;
        // const tp_scaled = xx ? tp1 : null;  //without scaling factor
        totalPressureDataRow.push(tp_scaled);
        staticPressureDataRow.push(xx ? eff : null); // FIX: Efficiency is dimensionless - do NOT scale it!
        staticAndTotalPressureDataRow.push([tp1 ? tp1 : null, xx ? eff : null]); // FIX: Efficiency unscaled
        // FIX: Use SCALED values for power calculation: Power = (TP_scaled * Airflow_scaled * 0.1) / Efficiency_unscaled
        fanShaftDataRow.push(tp_scaled && eff && airFlow ? (tp_scaled * airFlow * 0.1) / eff : null);
      }
      const pData = data[i].flow * (rpm2 / rpm1);
      // console.log("airdesnity", airDensity2)
      const pvValue = Math.pow((pData / getValues("netFreeArea")), 2) * 0.5 * (parseFloat(air_density2));
      totalPressureDataRow.push(pvValue);

      tmpTotalPressureData.push(totalPressureDataRow);
      tmpStaticPressureData.push(staticPressureDataRow);
      tmpStaticAndTotalPressureData.push(staticAndTotalPressureDataRow);
      tmpFanShaftData.push(fanShaftDataRow);
    }
    console.log(tmpStaticAndTotalPressureData)
    setTotalPressureData(tmpStaticAndTotalPressureData);
    setStaticPressureGraphData(tmpStaticPressureData);
    setTotalPressureGraphData(tmpTotalPressureData);
    setFanShaftGraphData(tmpFanShaftData);
    console.log(tmpTotalPressureData)
    console.log("##", {
      graphHeaderData,
      tmpTotalPressureData,
      tmpStaticPressureData,
      tmpFanShaftData,
      data,
      tmpStaticAndTotalPressureData
    });
  }

  const updateNewValues = (selectedFan: any) => {
    const selectedFanModelID = selectedFan.fanModelID;
    const selectedFanDiameter = selectedFan.fanDiameter;
    const selectedNumofBlades = selectedFan.numofBlades;
    const selectedModelId = selectedFan.bladeModel.bladeModelID;
    const selectedHubID = selectedFan.hub.hubID;
    const selectedGaDrawingID = selectedFan.gaDrawing.gaDrawingID;
    const selectedOctaveBandID = selectedFan.octaveBand.octaveBandID;
    const hubDiameter = userUpdatedData.hubDiameter || selectedFan.hub.hubDiameter; // Use userUpdatedData.hubDiameter

    const tipClarence = 0.0045 * selectedFanDiameter;
    const casingDiameter = selectedFanDiameter + (2 * tipClarence);
    const netFreeArea = 0.785 * ((casingDiameter * casingDiameter) - (hubDiameter * hubDiameter));

    const newValues: any = {
      fanModelID: selectedFanModelID,
      fanDiameter: selectedFanDiameter ? selectedFanDiameter.toFixed(3) : selectedFanDiameter,
      numofBlades: selectedNumofBlades ? selectedNumofBlades.toFixed(2) : selectedNumofBlades,
      bladeModel: selectedModelId,
      gaDrawing: selectedGaDrawingID,
      octaveBand: selectedOctaveBandID,
      hub: selectedHubID,
      hubDiameter, // Include hubDiameter in form data
      netFreeArea: netFreeArea ? netFreeArea.toFixed(2) : netFreeArea,
      performance_curves: selectedFan.performance_curves,
      rpm: selectedFan.rpm,
      curveType: selectedFan.curveType,
      fanCasingDiameter: casingDiameter ? casingDiameter.toFixed(2) : casingDiameter,
      airDensity2: selectedFan.airDensity2,
      rpm2: selectedFan.rpm2,
      airDensity: selectedFan.airDensity,
      clientName: selectedFan.clientName,
      projectName: selectedFan.projectName,
      location: selectedFan.location,
    };

    return new Promise((resolve, reject) => {
      try {
        resolve({ newValues });
      } catch (error) {
        resolve({ selectedFan });
      }
    });
  }

  const onSubmit: SubmitHandler<FanData> = async data => {
    const formDataWithAngles = {
      ...data,
      rpm2,
      airDensity2,
      // airDensity: airDensityDefault,
      performance_curves: performanceCurvesData
    };

    console.log("!!! Form Data with Angles", formDataWithAngles);

    let responseData: any;
    if (locationState.fanAction === 'Update') {
      responseData = await dispatch(updateModel(formDataWithAngles));
    } else {
      responseData = await dispatch(createNewModel(formDataWithAngles));
    }

    if (responseData.payload.error) {
      console.log("hi", responseData)
      setErrorResponse(responseData.payload.error.response.data.errors[0].fanModel);
    } else {
      history.push('/search');
    }
  };

  const handleRpm1Change = (event: any) => {
    const newRpm1 = parseFloat(event.target.value) || 1;
    const oldRpm1 = rpmDefault || 1;
    const currentRpm2 = rpm2 || oldRpm1;
    console.log(newRpm1, oldRpm1, currentRpm2);
    // Recalculate base values: current displayed values are at rpm2, need to convert to new rpm1
    // Current: base@oldRpm1 -> scaled to rpm2 (displayed)
    // New: need base@newRpm1 -> scaled to rpm2 (same display)
    // So: new_base = displayed / (rpm2/newRpm1) = displayed * (newRpm1/rpm2)

    const updatedPerformanceCurves = performanceCurvesData.map((curve: any) => {
      // Recalculate base flow at new RPM1
      const displayedFlow = curve.flow; // This is at rpm2
      const newBaseFlow = displayedFlow * (newRpm1 / currentRpm2);

      // Recalculate base TP at new RPM1 for each angle
      const updatedPlotPoints = curve.plotPoints.map((point: any) => {
        // Current displayed TP is scaled to rpm2
        // Need to find what base TP at newRpm1 would produce same displayed value
        const displayedTP = point.total_pressure;
        const newBaseTP = displayedTP / (Math.pow(currentRpm2 / newRpm1, 2) * (airDensity2 / (selectedFan.airDensity || 1.2)));

        return {
          ...point,
          total_pressure: newBaseTP
        };
      });

      return {
        ...curve,
        flow: newBaseFlow,
        plotPoints: updatedPlotPoints
      };
    });
    console.log("updated performance curve", updatedPerformanceCurves)
    setPerformanceCurves(updatedPerformanceCurves);
    setValue('performance_curves', updatedPerformanceCurves);
    setRpmDefault(newRpm1);
    setValue('rpm', newRpm1);

    // Update graph with new base values
    updateGraph();
  };

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    if (name === 'airDensity') {
      setAirDensityDefault(value);
    } else if (name === 'rpm') {
      setRpmDefault(value);
    } else if (name === 'rpm2') {
      // console.log("set rpm2 ran")
      setRpm2(value);
    } else if (name === 'airDensity2') {
      setAirDensity2(value);
    }
    setValue(name, value);
    updateGraph();
  };

  const handleAFChange = (rowIndex: number, colIndex: number, value: any) => {
    const updatedValues = [...totalPressureData];
    updatedValues[rowIndex][colIndex] = value;
    console.log("AF", value);
    setTotalPressureData(updatedValues);

    const updatedPerformanceCurves = [...performanceCurvesData];
    updatedPerformanceCurves[rowIndex] = {
      ...updatedPerformanceCurves[rowIndex],
      flow: parseFloat(value) || 0
    };
    setPerformanceCurves(updatedPerformanceCurves);
    updateGraph();
  };

  const handleTEandTPChange = (rowIndex: number, colIndex: number, colIndex2: number, value: any) => {
    const updatedValues = [...totalPressureData];
    updatedValues[rowIndex][colIndex][colIndex2] = value;
    console.log("TE,TP", value);
    console.log(updatedValues[rowIndex][colIndex][colIndex2])
    setTotalPressureData(updatedValues);

    const updatedPerformanceCurves = [...performanceCurvesData];
    const angle = angles[colIndex - 1];
    const plotPointIndex = updatedPerformanceCurves[rowIndex].plotPoints.findIndex(
      (point: any) => point.graphAngle === angle
    );
    console.log(rowIndex, colIndex, colIndex2, angle, plotPointIndex)
    if (plotPointIndex >= 0) {
      console.log("value", value)
      updatedPerformanceCurves[rowIndex].plotPoints[plotPointIndex] = {
        ...updatedPerformanceCurves[rowIndex].plotPoints[plotPointIndex],
        [colIndex2 === 0 ? 'total_pressure' : 'efficiency']: parseFloat(value) || null
      };
    }
    console.log(updatedPerformanceCurves[rowIndex].plotPoints[plotPointIndex])
    console.log("performanceCurveDatasave", updatedPerformanceCurves)
    setPerformanceCurves(updatedPerformanceCurves);
    updateGraph();
  };

  const handleAngleChange = (slotIndex: number, value: any) => {
    const nextAngle = String(value).trim();

    setAngles((prevAngles) => {
      const prevAngle = String(prevAngles[slotIndex] ?? "").trim();

      // no-op
      if (!nextAngle || prevAngle === nextAngle) return prevAngles;

      // 🚫 block duplicates across the angles slots (except the one being edited)
      const isDuplicate = prevAngles.some(
        (a, i) => i !== slotIndex && String(a).trim() === nextAngle
      );
      if (isDuplicate) {
        console.warn(`Duplicate angle blocked: ${nextAngle}`);
        return prevAngles;
      }

      // ✅ update curves by matching the OLD angle value inside each curve
      setPerformanceCurves((prevCurves) =>
        prevCurves.map((curve) => {
          const idx = curve.plotPoints.findIndex(
            (p: any) => String(p.graphAngle).trim() === prevAngle
          );

          // This curve doesn't have that old angle (common when plotPoints are shorter)
          if (idx === -1) return curve;

          const newPlotPoints = curve.plotPoints.map((p: any, i: any) =>
            i === idx ? { ...p, graphAngle: nextAngle } : p
          );

          return { ...curve, plotPoints: newPlotPoints };
        })
      );

      const nextAngles = [...prevAngles];
      nextAngles[slotIndex] = nextAngle;
      return nextAngles;
    });
    updateGraph();
  };

  // ---------- ONLY CHANGED FUNCTION ----------
  const updateGraph = () => {
    console.log("I am hit")
    const updatedTotalPData = [...totalPressureGraphData.slice(1)];
    const updatedStaticPData = [...staticPressureGraphData.slice(1)];
    const updatedFanShaftData = [...FanShaftGraphData.slice(1)];
    const performanceCurves = [...performanceCurvesData];
    console.log(performanceCurves)
    const selectedFanInput = { ...getValues() };
    console.log(selectedFanInput)
    const rpm1 = selectedFanInput.rpm ? parseInt(selectedFanInput.rpm) : 1;
    const rpm2V = selectedFanInput.rpm2 ? parseInt(selectedFanInput.rpm2) : rpm1;
    const air_density1 = selectedFanInput.airDensity ? selectedFanInput.airDensity : 1.2; // FIX: Changed from 0.5 to 1.2
    const air_density2V = airDensity2 ? airDensity2 :selectedFanInput.airDensity2;
    const formulaApply = (rpm2V / rpm1) * (air_density2V / air_density1);
    console.log("rpm2 value", rpm2V,air_density2V)
    const toNumOrNull = (v: any): number | null =>
      v === '' || v === null || v === undefined ? null : Number(v);
    const isPosNum = (v: unknown): v is number =>
      typeof v === 'number' && isFinite(v) && v > 0;

    totalPressureData.forEach((row, rowIndex) => {
      let airFlow = 0;
      row.forEach((value: any, colIndex: any) => {
        if (Array.isArray(value)) {
          // value = [TP, TE] (unscaled)


          const tpRaw = toNumOrNull(value[0]);
          const teRaw = toNumOrNull(value[1]);

          let tp: number | null = null;
          let tf: number | null = null;
          let tpValid = false;
          let teValid = false;

          // ✅ Narrow the variable directly
          if (isPosNum(tpRaw)) {
            tpValid = true;
            tp = tpRaw * formulaApply * (rpm2V / rpm1);         // tpRaw is number here
          }
          if (isPosNum(teRaw)) {
            teValid = true;
            tf = teRaw;  // FIX: Efficiency is dimensionless - do NOT scale it!
          }

          // Only compute shaft power when both valid and airflow > 0
          const fsd = tpValid && teValid && airFlow > 0 ? (tp! * airFlow * 0.1) / (tf!) : null;

          if (updatedTotalPData[rowIndex]) {
            updatedTotalPData[rowIndex][colIndex] = tp;
            updatedStaticPData[rowIndex][colIndex] = tf;
            updatedFanShaftData[rowIndex][colIndex] = fsd;

            // const angle = angles[colIndex - 1];
            // const plotPointIndex = performanceCurves[rowIndex].plotPoints.findIndex(
            //   (point: any) => point.graphAngle === angle
            // );
            // if (plotPointIndex >= 0) {
            //   performanceCurves[rowIndex].plotPoints[plotPointIndex] = {
            //     ...performanceCurves[rowIndex].plotPoints[plotPointIndex],
            //     total_pressure: tpValid ? tp  : null,
            //     efficiency: teValid ? tf : null
            //   };
            // }
          }
        } else {
          // first column = airflow (unscaled). Keep previous behaviour.
          const baseAF = value === '' || value === null || value === undefined ? null : Number(value);
          const formulatedAirflow = baseAF === null ? null : ((rpm2V / rpm1) * (parseFloat(value) || 0));
          console.log(formulatedAirflow);
          if (updatedTotalPData[rowIndex]) {
            updatedTotalPData[rowIndex][colIndex] = isNaN(Number(formulatedAirflow)) ? null : formulatedAirflow;
            updatedStaticPData[rowIndex][colIndex] = isNaN(Number(formulatedAirflow)) ? null : formulatedAirflow;
            updatedFanShaftData[rowIndex][colIndex] = isNaN(Number(formulatedAirflow)) ? null : formulatedAirflow;
            // performanceCurves[rowIndex].flow = isNaN(Number(formulatedAirflow)) ? null : formulatedAirflow;
          }
          // FIX: Use the FORMULATED airflow (with Fan Law applied) for power calculation, not unscaled base
          airFlow = formulatedAirflow || 0;
        }
      });
      const netArea = getValues("netFreeArea");

    const pv =
      airFlow && netArea
        ? 0.5 * air_density2V * Math.pow(airFlow / netArea, 2)
        : null;

    if (updatedTotalPData[rowIndex]) {
      updatedTotalPData[rowIndex][updatedTotalPData[rowIndex].length - 1] = pv;
    }
    });

    let hederRow = ['Airflow', ...angles];
    updatedTotalPData.unshift([...hederRow,'PV']);
    updatedStaticPData.unshift(hederRow);
    updatedFanShaftData.unshift(hederRow);

    setTotalPressureGraphData(updatedTotalPData);
    console.log(updatedTotalPData)
    setStaticPressureGraphData(updatedStaticPData);
    setFanShaftGraphData(updatedFanShaftData);
    // setPerformanceCurves(performanceCurves);
    // setValue('performance_curves', performanceCurves);
    console.log("I am runing")
  };
  // ---------- /ONLY CHANGED FUNCTION ----------

  const addAngle = () => {
    const angelNew = [...angles];
    let newAngle = angelNew.length > 0 ? parseInt(angelNew[angelNew.length - 1]) + 1 : 1;
    const updatedAngles = [...angles, newAngle.toString()];
    setAngles(updatedAngles);

    const newTotalPressureDataAdded = totalPressureData.map((item) => {
      return [...item, [null, null]];
    });
    setTotalPressureData(newTotalPressureDataAdded);

    const updatedPerformanceCurves = [...performanceCurvesData];
    updatedPerformanceCurves.forEach(curve => {
      curve.plotPoints.push({
        graphAngle: newAngle.toString(),
        efficiency: null,
        pv: 0,
        static_pressure: null,
        total_pressure: null
      });
    });
    setPerformanceCurves(updatedPerformanceCurves);
    updateGraph();
  };

  const removeAngle = (angle: string) => {
    let tmpAngles = [...angles];
    let indexOfAngle = tmpAngles.indexOf(angle);
    tmpAngles.splice(indexOfAngle, 1);
    setAngles(tmpAngles);

    const newTotalPressureDataAdded = totalPressureData.map((item) => {
      const newItem = [...item];
      newItem.splice(indexOfAngle + 1, 1);
      return newItem;
    });
    setTotalPressureData(newTotalPressureDataAdded);

    const updatedPerformanceCurves = [...performanceCurvesData];
    updatedPerformanceCurves.forEach(curve => {
      curve.plotPoints = curve.plotPoints.filter((point: any) => point.graphAngle !== angle);
    });
    setPerformanceCurves(updatedPerformanceCurves);
    updateGraph();
  };

  const addRows = () => {
    const rows: any = [null];
    angles.forEach(() => {
      rows.push([null, null]);
    });
    const newTotalPressureData = [...totalPressureData, rows];
    const newPerformanceCurvesData = [...performanceCurvesData, {
      flow: 0,
      plotPoints: angles.map(angle => ({
        graphAngle: angle,
        efficiency: null,
        pv: 0,
        static_pressure: null,
        total_pressure: null
      }))
    }];
    setPerformanceCurves(newPerformanceCurvesData);
    setTotalPressureData(newTotalPressureData);
    updateGraph();
  };

  const removeRows = (index: number) => {
    const newTotalPressureData = [...totalPressureData];
    newTotalPressureData.splice(index, 1);
    const newPerformanceCurvesData = [...performanceCurvesData];
    newPerformanceCurvesData.splice(index, 1);
    setTotalPressureData(newTotalPressureData);
    setPerformanceCurves(newPerformanceCurvesData);
    updateGraph();
  };
  const curveSrcArr = [
    { key: 'Test', text: 'Test' },
    { key: 'Legacy', text: 'Legacy' },
    { key: 'All', text: 'All (Test & Legacy)' }
  ];


  return (
    <div className="page-wrapper">
      <Container maxWidth="xl">
        <Paper className="form-wrapper">
          <Typography variant="h5" gutterBottom>
            <b className={classes.uppercaseText}> Fan Details</b>
          </Typography>
          <hr />
          <Divider />

          <AlertComponent open={openAlert} message={openAlertMesage} severity="success" handleClose={() => { setOpenAlert(false) }} />

          <form id="fan-details-form" style={{ padding: '5px' }} onSubmit={handleSubmit(onSubmit)}>
            {!inputValue && (buttonAction === 'Duplicate') && (
              <p className="MuiFormHelperText-root MuiFormHelperText-contained" style={{ color: 'red' }}>Add new model number</p>
            )}
            {modelExistError && (
              <>
                <p className="MuiFormHelperText-root MuiFormHelperText-contained" style={{ color: 'red' }}>{modelExistError}</p>
                <br />
              </>
            )}

            <Grid container spacing={3}>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled={fieldDisabled.fanModelID}
                  label="Fan Model"
                  variant="outlined" fullWidth
                  {...register("fanModelID", { required: true })}
                  helperText={errors.fanModelID ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled={fieldDisabled.fanDiameter}
                  label="Fan Diameter(m)"
                  variant="outlined" fullWidth
                  {...register("fanDiameter", { required: true })}
                  helperText={errors.fanDiameter ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled={fieldDisabled.airDensity}
                  label="Air Density (kg/m^3)"
                  variant="outlined" fullWidth
                  {...register("airDensity", { required: true })}
                  onChange={(e) => handleChange(e)}
                  helperText={errors.airDensity ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  type='number'   //added type field to restrict only ineger entries.
                  InputLabelProps={{ shrink: true }}
                  disabled={fieldDisabled.numofBlades}
                  label="No of Blades"
                  variant="outlined" fullWidth
                  {...register("numofBlades", { required: true })}
                  onChange={(e) => handleChange(e)}
                  helperText={errors.numofBlades ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled={fieldDisabled.rpm}
                  label="Fan RPM 1"
                  variant="outlined" fullWidth
                  {...register("rpm", { required: false })}
                  onChange={(e) => handleChange(e)}
                  helperText={errors.rpm ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled={fieldDisabled.curveType}
                  label="Curve Type "
                  variant="outlined"
                  fullWidth
                  select
                  value={getValues("curveType") || "All"}
                  {...register("curveType", { required: true })}
                  onChange={e => {
                    setValue("curveType", e.target.value);
                    handleChange(e);
                  }}
                  helperText={errors.curveType ? 'This field is required' : ''}
                >
                  {curveSrcArr.map(el => (
                    <MenuItem key={el.key} value={el.key}>{el.text}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled={fieldDisabled.netFreeArea}
                  label="Net Free Area (m^2)"
                  variant="outlined" fullWidth
                  {...register("netFreeArea", { required: true })}
                  helperText={errors.netFreeArea ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled={fieldDisabled.fanCasingDiameter}
                  label="Fan Casing Diameter (m)"
                  variant="outlined" fullWidth
                  {...register("fanCasingDiameter", { required: true })}
                  helperText={errors.fanCasingDiameter ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled={fieldDisabled.bladeModel}
                  label="Blade Model Number"
                  variant="outlined" fullWidth
                  {...register("bladeModel", { required: true })}
                  helperText={errors.bladeModel ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled={fieldDisabled.hub}
                  label="Hub ID"
                  variant="outlined" fullWidth
                  {...register("hub", { required: true })}
                  helperText={errors.hub ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled={fieldDisabled.octaveBand}
                  label="Octave ID"
                  variant="outlined" fullWidth
                  {...register("octaveBand", { required: true })}
                  helperText={errors.octaveBand ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled={fieldDisabled.gaDrawing}
                  label="GA Drawing ID"
                  variant="outlined" fullWidth
                  {...register("gaDrawing", { required: true })}
                  helperText={errors.gaDrawing ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled={fieldDisabled.hubDiameter}
                  label="Hub Diameter (m)"
                  variant="outlined" fullWidth
                  {...register("hubDiameter", { required: true })}
                  helperText={errors.hubDiameter ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={4}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled={fieldDisabled.clientName}
                  label="Client Name"
                  variant="outlined" fullWidth
                  {...register("clientName")}
                  helperText={errors.clientName ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={4}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled={fieldDisabled.projectName}
                  label="Project Name"
                  variant="outlined" fullWidth
                  {...register("projectName")}
                //helperText={errors.projectName ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={4}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled={fieldDisabled.location}
                  label="Location"
                  variant="outlined" fullWidth
                  {...register("location")}
                  helperText={errors.location ? 'This field is required' : ''}
                />
              </Grid>
            </Grid>

            <Grid container spacing={6}>
              <Grid item xs={12} lg={12}>
                <Typography variant="h5" gutterBottom style={{ textAlign: "center" }}>
                  <b> AIRFLOW VS TOTAL PRESSURE & TOTAL EFFICIENCY</b>
                </Typography>
              </Grid>
            </Grid>

            <TableContainer component={Paper} style={{ marginRight:'auto',marginLeft:'auto',width: 'auto', overflowX: 'auto' }}>
              <Table aria-label="simple table" style={{ zoom: 0.8 }}>
                <TableHead>
                  <TableRow>
                    <TableCell><b></b></TableCell>
                    <TableCell><b></b></TableCell>
                    {angles.map((angle, i) => (
                      <TableCell key={"angle" + i} align="center" style={{ border: '1px solid #FFF', borderRadius: "5px", background: "#e0e0e0" }}>
                        <TextField
                          variant="outlined"
                          style={{ width: '250px' }}
                          value={parseInt(angle)}
                          className={classes.textField}
                          type="number"
                          onChange={(e) => handleAngleChange(i, e.target.value)}
                        />
                        <Button variant="contained" style={{ background: "#d39797", lineHeight: "40px", margin: '0 4px' }} onClick={() => removeAngle(angle)}>X</Button>
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <span style={{ marginRight: '8px' }}> </span>
                        <span className={classes.cellBox}><b>Airflow</b></span>
                      </div>
                    </TableCell>
                    <TableCell>
                      <span className={classes.cellBox}> </span>
                    </TableCell>
                    {angles.map((angle, i) => (
                      <TableCell key={"header" + i} align="center">
                        <div style={{ width: '350px', display: 'flex', justifyContent: 'end' }}>
                          <span className={classes.cellBox}><b>TP</b></span>
                          <span className={classes.cellBox}><b>TE</b></span>
                        </div>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {totalPressureData.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      <TableCell component="td" scope="row">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Button variant="contained" style={{ background: "#d39797", lineHeight: "40px", margin: '0 4px' }} onClick={() => removeRows(rowIndex)}>X</Button>
                          <TextField
                            variant="outlined"
                            value={row[0]}
                            className={classes.textField}
                            style={{ width: '120px', marginLeft: '8px' }}
                            type="number"
                            onChange={(e) => handleAFChange(rowIndex, 0, e.target.value)}
                          />
                        </div>
                      </TableCell>
                      <TableCell>
                        {/* Empty cell to match the header structure */}
                      </TableCell>
                      {row.map((value: any, colIndex: any) => (
                        <React.Fragment key={colIndex}>
                          {colIndex > 0 && (
                            <TableCell align="center">
                              <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                {value && value.map((value2: any, colIndex2: any) => (
                                  <span key={colIndex2} className={classes.cellBox}>
                                    <TextField
                                      variant="outlined"
                                      value={value2}
                                      className={classes.textField}
                                      style={{ width: '120px' }}
                                      type='number'
                                      onChange={(e) => handleTEandTPChange(rowIndex, colIndex, colIndex2, e.target.value)}
                                    />
                                  </span>
                                ))}
                              </div>
                            </TableCell>
                          )}
                        </React.Fragment>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <br />
            <br />
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <Typography variant="h5" gutterBottom style={{ textAlign: "center" }}>
                  <Button variant="contained" onClick={addRows}>Add rows</Button>
                  <Button variant="contained" style={{ marginLeft: "10px" }} onClick={addAngle}>Add angles</Button>
                </Typography>
              </Grid>
            </Grid>
            <br />
            <br />

            <Grid container spacing={3}>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled={fieldDisabled.airDensity2}
                  label="Air Density 2 (Kg/m^3)"

                  variant="outlined" fullWidth
                  value={airDensity2}
                  //{...register("airDensity2", { required: true })}
                  onChange={e => {
                    setAirDensity2(e.target.value); // update local state if needed
                    setValue("airDensity2", Number(e.target.value)); // update react-hook-form
                    handleChange(e);   // your custom logic if needed
                  }}
                  helperText={errors.airDensity2 ? 'This field is required' : ''}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled={fieldDisabled.rpm2}
                  label="Rpm2"
                  // name="rpm2"
                  //onChange={(e) => handleChange(e)}
                  variant="outlined" fullWidth
                  value={rpm2}
                  //{...register("rpm2", { required: true })}
                  onChange={e => {
                    setRpm2(e.target.value); // update local state if needed
                    setValue("rpm2", Number(e.target.value)); // update react-hook-form
                    handleChange(e);   // your custom logic if needed
                  }}
                  helperText={errors.rpm2 ? 'This field is required' : ''}
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <Typography variant="h5" gutterBottom style={{ textAlign: "center" }}>
                  <b> TOTAL PRESSURE VS AIRFLOW</b>
                </Typography>
                {totalPressureGraphData && <Chart
                  width={'100%'}
                  height={'400px'}
                  chartType="LineChart"
                  loader={<div>Loading Chart</div>}
                  data={totalPressureGraphData}
                  options={{
                    ...options,
                    hAxis: {
                      ...options.hAxis,
                      title: 'Airflow (m³/sec)', // X axis unit
                      format: "0"
                    },
                    vAxis: {
                      ...options.vAxis,
                      title: 'Total Pressure(Pascal)', // <-- Add unit here
                      format: "0"
                    }
                  }}
                />}
                {
                }
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <Typography variant="h5" gutterBottom style={{ textAlign: "center" }}>
                  <b> FAN SHAFT POWER vs AIRFLOW </b>
                </Typography>
                {FanShaftGraphData && <Chart
                  width={'100%'}
                  height={'400px'}
                  chartType="LineChart"
                  loader={<div>Loading Chart</div>}
                  data={FanShaftGraphData}
                  options={{
                    ...options,
                    hAxis: {
                      ...options.hAxis,
                      title: 'Airflow (m³/sec)', // X axis unit
                      format: "0"
                    },
                    vAxis: {
                      ...options.vAxis,
                      title: 'Fan Shaft Power(kW)', // <-- Add unit here
                      format: "0"
                    }
                  }}
                />}
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <Typography variant="h5" gutterBottom style={{ textAlign: "center" }}>
                  <b> TOTAL EFFICIENCY VS AIRFLOW </b>
                </Typography>
                {staticPressureGraphData && <Chart
                  width={'100%'}
                  height={'400px'}
                  chartType="LineChart"
                  loader={<div>Loading Chart</div>}
                  data={staticPressureGraphData}
                  options={{
                    ...options,
                    hAxis: {
                      ...options.hAxis,
                      title: 'Airflow (m³/sec)', // X axis unit
                      format: "0"
                    },
                    vAxis: {
                      ...options.vAxis,
                      title: 'Total Effeciency(%)', // <-- Add unit here
                      format: "0"
                    }
                  }}
                />}
              </Grid>
            </Grid>

            <Grid container style={{ textAlign: "center" }}>
              <Grid item xs={12} lg={12}>
                <Button style={{ backgroundColor: '#41bb98' }} variant="contained" color="primary" onClick={onBack} className={classes.radioWrapped}> Back </Button>
                <Button variant="contained" color="secondary" type='submit' style={{ backgroundColor: 'rgb(245 154 36)' }} className={classes.radioWrapped}>
                  {locationState.fanAction === 'Update' ? 'Update' : 'Create'}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Container>
    </div>
  );
}

export default FanDetails;
